"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOpt = exports.fetchUserOptSettings = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _UserInfoAPI = require("./UserInfoAPI");

var BASE_OPTINS_URL = '/optins/v1/availability';
var ERROR = 'Error';

var availabilityUrl = function availabilityUrl(optinName, hubOverride) {
  return BASE_OPTINS_URL + "/" + optinName + (hubOverride ? '/hub-override' : '');
};

var toError = function toError(error) {
  throw new Error(error && error.responseJSON && error.responseJSON.message || ERROR);
};

var fetchOptinAvailability = function fetchOptinAvailability(optinName) {
  return _apiClient.default.get(availabilityUrl(optinName)).catch(toError);
};

var getQuickFetchedOptinAvailability = function getQuickFetchedOptinAvailability(optinName) {
  var quickFetchKey = "optin-" + optinName;
  var quickFetchedOptinAvailability = window.quickFetch && window.quickFetch.getRequestStateByName(quickFetchKey);

  if (quickFetchedOptinAvailability) {
    return new Promise(function (resolve, reject) {
      quickFetchedOptinAvailability.whenFinished(function (availability) {
        resolve(availability);
        window.quickFetch.removeEarlyRequest(quickFetchKey);
      });
      quickFetchedOptinAvailability.onError(function (__, errorMsg) {
        reject(errorMsg);
        window.quickFetch.removeEarlyRequest(quickFetchKey);
      });
    });
  }

  return null;
};

var getOptinAvailability = function getOptinAvailability(optinName) {
  var quickFetchedOptinAvailabilityPromise = getQuickFetchedOptinAvailability(optinName);

  if (quickFetchedOptinAvailabilityPromise) {
    return quickFetchedOptinAvailabilityPromise;
  }

  return fetchOptinAvailability(optinName);
};

var fetchUserOptSettings = function fetchUserOptSettings(optinName) {
  return Promise.all([(0, _UserInfoAPI.getUserInfo)().then(function (_ref) {
    var user = _ref.user;
    return user;
  }), getOptinAvailability(optinName)]).then(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        user = _ref3[0],
        availability = _ref3[1];

    return {
      availability: availability,
      user: user
    };
  });
};

exports.fetchUserOptSettings = fetchUserOptSettings;

var updateOpt = function updateOpt(_ref4) {
  var stateActionAt = _ref4.availability.stateActionAt,
      optinName = _ref4.optinName,
      hubOverride = _ref4.hubOverride,
      newOptinState = _ref4.newOptinState;
  return _apiClient.default.put(availabilityUrl(optinName, hubOverride) + "/" + newOptinState + "?currentActionAt=" + stateActionAt).catch(toError);
};

exports.updateOpt = updateOpt;